export default __webpack_public_path__ + "media/images/check-8db0b7858c296479930eb036ea586e12.svg";